import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
//import 'element-ui/lib/element-#4A65FB/index.css';
//import 'element-ui/lib/theme-chalk/index.css';
import './views/theme/index.css'
import hrraxios from './hrraxios'
import api from './api'
import GlobalComponent from './GlobalComponent'
import common from './common.js'
import VCharts from 'v-charts'
import 'v-charts/lib/style.css'
import moment from 'vue-moment'
import Print from 'vue-print-nb'
import VueAMap from './amap.js'
import i18n from './lang/vueIN'

// 引入mockjs
//require('./mock.js');

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(api)
Vue.use(hrraxios)
Vue.use(GlobalComponent)
Vue.use(common)
Vue.use(VCharts)
Vue.use(moment)
Vue.use(Print)
Vue.use(VueAMap)
Vue.use(common)

new Vue({
  router,
  store,
  i18n, // 挂载
  render: (h) => h(App),
}).$mount('#app')
